import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import {Spinner} from 'react-bootstrap'
import React from 'react'

export default function StackedBarChart(props) {
    const totalTitle = props.totalName || 'Total';

    const getSeriesByIndex = (index) => {
        switch (index) {
            case 2: {
                return 'Minor Flow'
                break;
            }
            case 1: {
                return 'Moderate Flow'
                break;
            }
            case 0: {
                return 'Major Flow'
                break;
            }
        }
    }

    const calculatePlotBands = () => {
        let plotBandArray = [];
        let currentFrom = -0.15;
        let currentTo = 0.15

        props.selectedEntities.forEach(obj => {
            plotBandArray.push({
                to: currentTo, color: "#E6E6E6", from: currentFrom
            })
            currentTo = currentTo + 1;
            currentFrom = currentFrom + 1;

        })
        return plotBandArray
    }

    const options = {
        chart: {
            type: props.horizontal ? 'bar' : 'column', height: props.height, scrollablePlotArea: props.scrollbar ? {
                minHeight: props.minScrollHeight || 200, opacity: 10
            } : null
        }, title: {
            text: props.title
        }, xAxis: {
            categories: props.categories,
            crosshair: true,
            plotBands: props.isPieChart ? calculatePlotBands() : [],
            labels: props.isPieChart ? {
                align: 'left', x: 3, y: props.labelYPPosition, style: {
                    whiteSpace: 'nowrap',
                },
            } : {}
        }, yAxis: {
            labels: {
                enabled: !props.isPieChart
            }, min: 0, title: {
                text: 'Leaks'
            },
        }, tooltip: {
            formatter: function () {
                let dataToShow = [];
                for (let i = 2; i >= 0; i--) {
                    dataToShow.push('<br/>' + getSeriesByIndex(i) + ': ' + this.series.chart.series[i].data[this.point.index]?.y.toLocaleString());
                }
                if (this.series.name === 'Water consumption') {
                    return `<b>${this.x}</b><br/>${this.series.name}: ${this.y.toLocaleString()} ${props.volumeUnit}`;
                } else {
                    return `<p class=font-weight-bold>${this.x}</p>${dataToShow.toLocaleString().replaceAll(',', '')}<br/>${totalTitle}: ${this.point.stackTotal.toLocaleString()}`;
                }
            }
        }, plotOptions: {
            column: {
                pointPadding: 0.1, borderWidth: 0, stacking: 'normal'
            }, bar: {
                pointPadding: 0, stacking: 'normal', pointWidth: props.chartPointWidth, groupPadding: 0
            }, series: {
                events: {
                    click: function (event) {
                        if (props.onClick) {
                            props.onClick(event);
                        }
                    }
                }, dataLabels: props.isPieChart ? {
                    enabled: true, align: "left", x: 2000, y: -20, style: {
                        position: 'absolute', fontSize: 12, color: 'black'

                    }, formatter: function () {
                        if (this.series.name === "High Flow") {
                            return '<div>' + this.point.stackTotal.toLocaleString() + '</div>'
                        }
                    }
                } : {}
            }
        }, credits: {
            enabled: false
        }, series: props.data,
    }

    const options1 = {
        chart: {
            type: props.horizontal ? 'bar' : 'column', height: props.height, scrollablePlotArea: props.scrollbar ? {
                minHeight: props.minScrollHeight || 200, opacity: 10
            } : null
        }, title: {
            text: props.title
        }, xAxis: {
            categories: props.categories, crosshair: true, plotBands: props.isPieChart ? [{
                to: 0.05, color: "#E6E6E6", from: -0.05
            }] : [], labels: props.isPieChart ? {
                align: 'left', x: 3, y: props.labelYPPosition, style: {
                    whiteSpace: 'nowrap',
                },
            } : {}
        }, yAxis: {
            labels: {
                enabled: !props.isPieChart
            }, min: 0, title: {
                text: 'Leaks'
            },
        }, tooltip: {
            formatter: function () {
                let dataToShow = [];
                for (let i = 2; i >= 0; i--) {
                    dataToShow.push('<br/>' + getSeriesByIndex(i) + ': ' + this.series.chart.series[i].data[this.point.index].y.toLocaleString());
                }
                if (this.series.name === 'Water consumption') {
                    return `<b>${this.x}</b><br/>${this.series.name}: ${this.y.toLocaleString()} ${props.volumeUnit}`;
                } else {
                    return `${dataToShow.toString().replaceAll(',', '')}<br/>${totalTitle}: ${this.point.stackTotal.toLocaleString()}`;
                }
            }
        }, plotOptions: {
            column: {
                pointPadding: 0.1, borderWidth: 0, stacking: 'normal'
            }, bar: {
                pointPadding: 0, stacking: 'normal', pointWidth: props.chartPointWidth, groupPadding: 0
            }, series: {
                events: {
                    click: function (event) {
                        if (props.onClick) {
                            props.onClick(event);
                        }
                    }
                }, dataLabels: props.isPieChart ? {
                    enabled: true, align: "left", x: 2000, y: -20, style: {
                        position: 'absolute', fontSize: 12, color: 'black'
                    }, formatter: function () {
                        if (this.series.name === "High Flow") {
                            return '<div>' + this.point.stackTotal + '</div>'
                        }
                    }
                } : {}
            }
        }, credits: {
            enabled: false
        }, series: props.data,
    }

    const options2 = {
        chart: {
            type: props.horizontal ? 'bar' : 'column', height: props.height, scrollablePlotArea: props.scrollbar ? {
                minHeight: props.minScrollHeight || 200, opacity: 10
            } : null
        }, title: {
            text: props.title
        }, xAxis: {
            categories: props.categories, crosshair: true, plotBands: props.isPieChart ? [{
                to: 0.09, color: "#E6E6E6", from: -0.09
            }, {
                to: 1.09, color: "#E6E6E6", from: 0.91
            }] : [], labels: props.isPieChart ? {
                align: 'left', x: 3, y: props.labelYPPosition, style: {
                    whiteSpace: 'nowrap',
                },
            } : {}
        }, yAxis: {
            labels: {
                enabled: !props.isPieChart
            }, min: 0, title: {
                text: 'Leaks'
            },
        }, tooltip: {
            formatter: function () {
                let dataToShow = [];
                for (let i = 2; i >= 0; i--) {
                    dataToShow.push('<br/>' + getSeriesByIndex(i) + ': ' + this.series.chart.series[i].data[this.point.index].y.toLocaleString());
                }
                if (this.series.name === 'Water consumption') {
                    return `<b>${this.x}</b><br/>${this.series.name}: ${this.y}<br/>`;
                } else {
                    return `${dataToShow.toString().replaceAll(',', '')}<br/>${totalTitle}: ${this.point.stackTotal.toLocaleString()}`;
                }
            }
        }, plotOptions: {
            column: {
                pointPadding: 0.1, borderWidth: 0, stacking: 'normal'
            }, bar: {
                pointPadding: 0, stacking: 'normal', pointWidth: props.chartPointWidth, groupPadding: 0
            }, series: {
                events: {
                    click: function (event) {
                        if (props.onClick) {
                            props.onClick(event);
                        }
                    }
                }, dataLabels: props.isPieChart ? {
                    enabled: true, align: "left", x: 2000, y: -20, style: {
                        position: 'absolute', fontSize: 12, color: 'black'

                    }, formatter: function () {
                        if (this.series.name === "Major Flow") {
                            return '<div>' + this.point.stackTotal.toLocaleString() + '</div>'
                        }
                    }
                } : {}
            }
        }, credits: {
            enabled: false
        }, series: props.data,
    }

    if (props.selectedEntities) {
        if (props.selectedEntities.length === 1) {
            return (<>
                {!props.data && <Spinner animation="border" variant="primary"/>}
                {props.data && <HighchartsReact
                    highcharts={Highcharts}
                    options={options1}
                />}
            </>)
        }
        if (props.selectedEntities.length === 2) {
            return (<>
                {!props.data && <Spinner animation="border" variant="primary"/>}
                {props.data && <HighchartsReact
                    highcharts={Highcharts}
                    options={options2}
                />}
            </>)
        }
    }

    return (<>
        {!props.data && <Spinner animation="border" variant="primary"/>}
        {props.data && <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />}
    </>)
}
